import React from 'react'
import StatsCount from '../statsCount/StatsCount'
import StatsScore from '../statsScore/StatsScore'
import StatsTime from '../statsTime/StatsTime'

const Stats = React.forwardRef(function Stats(
  { eventBus, score, maxLifes, maxScore, coins, targetCoins, lives, count, timer, type },
  ref,
) {
  return (
    <>
      <StatsCount
        count={count}
        targetCoins={targetCoins}
        type={type}
      />

      <StatsScore
        score={score}
        maxScore={maxScore}
      />

      <StatsTime
        eventBus={eventBus}
        timer={timer}
        type={type}
      />
    </>
  )
})
export default Stats
Stats.propTypes = {}
